import { api } from './client';
import type { CommunityTripSummary, CommunityTripDetail, Trip } from '../types';

export type CommunityActivityType =
  | 'RESTAURANT' | 'CAFE' | 'MONUMENT' | 'VIEWPOINT' | 'NEIGHBORHOOD'
  | 'PARK' | 'SHOP' | 'EXPERIENCE' | 'TRANSPORT' | 'PARKING' | 'BEACH' | 'NATURE' | 'ACCOMMODATION' | 'OTHER';

export interface ListCommunityParams {
  q?: string;
  destination?: string;
  minNights?: number;
  maxNights?: number;
  minBudgetPerDay?: number;
  maxBudgetPerDay?: number;
  activityTypes?: CommunityActivityType[];
  startMonth?: number;
  minParticipants?: number;
  maxParticipants?: number;
  sort?: 'recent' | 'top_rated' | 'most_cloned';
  limit?: number;
  offset?: number;
  feed?: 'following';
  authorId?: string;
}

export interface CloneCommunityPayload {
  startDate?: string;
  name?: string;
  selectedDayIds?: string[];
}

export const communityApi = {
  list: (params?: ListCommunityParams) => {
    const serialized: Record<string, any> = { ...params };
    if (params?.activityTypes && params.activityTypes.length > 0) {
      serialized.activityTypes = params.activityTypes.join(',');
    } else {
      delete serialized.activityTypes;
    }
    return api
      .get<{ trips: CommunityTripSummary[]; total: number }>('/community/trips', { params: serialized })
      .then(r => r.data);
  },

  get: (tripId: string) =>
    api.get<CommunityTripDetail>(`/community/trips/${tripId}`).then(r => r.data),

  rate: (tripId: string, stars: number) =>
    api.post<{ stars: number; avgRating: number | null; ratingCount: number }>(
      `/community/trips/${tripId}/rate`, { stars },
    ).then(r => r.data),

  clone: (tripId: string, payload: CloneCommunityPayload = {}) =>
    api.post<Trip>(`/community/trips/${tripId}/clone`, payload).then(r => r.data),
};
